import Vue from 'vue'
import Router from 'vue-router'
import store from './store'
import { AUTH_MODULE } from './store/modules'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import(/* webpackChunkName: "home" */'./views/Home'),
      meta: {
        background: true
      },
      props: {
        type: 'home'
      }
    },
    {
      path: '/functionality',
      name: 'home.functionality',
      component: () => import(/* webpackChunkName: "home" */'./views/Home'),
      meta: {
        background: true
      },
      props: {
        type: 'functionality'
      }
    },
    {
      path: '/papers',
      name: 'home.papers',
      component: () => import(/* webpackChunkName: "home" */'./views/Home'),
      meta: {
        background: true
      },
      props: {
        type: 'papers'
      }
    },
    {
      path: '/press',
      name: 'home.press',
      component: () => import(/* webpackChunkName: "home" */'./views/Home'),
      meta: {
        background: true
      },
      props: {
        type: 'press'
      }
    },
    {
      path: '/patents',
      name: 'home.patents',
      component: () => import(/* webpackChunkName: "home" */'./views/Home'),
      meta: {
        background: true
      },
      props: {
        type: 'patents'
      }
    },
    {
      path: '/diplomas',
      name: 'home.diplomas',
      component: () => import(/* webpackChunkName: "home" */'./views/Home'),
      meta: {
        background: true
      },
      props: {
        type: 'diplomas'
      }
    },
    {
      path: '/legal_information',
      name: 'legalInformation',
      component: () => import(/* webpackChunkName: "legalInformation" */'./views/LegalInformation'),
      meta: {
        background: true
      }
    },
    {
      path: '/corpus-rusavic',
      name: 'corpus',
      component: () => import(/* webpackChunkName: "Сorpus" */'./views/Сorpus'),
      meta: {
        background: true
      }
    },
    {
      path: '/panel/map',
      name: 'panelMap',
      component: () => import(/* webpackChunkName: "panelMap" */'./views/panel/ManagerMap'), // import(/* webpackChunkName: "panelMap" */'./views/panel/Map'),
      meta: {
        auth: true
      }
    },
    {
      path: '/panel/charts',
      name: 'panelCharts',
      component: () => import(/* webpackChunkName: "panelCharts" */'./views/panel/Charts'),
      meta: {
        auth: true
      }
    },
    {
      path: '/panel/reports',
      name: 'panelReports',
      component: () => import(/* webpackChunkName: "panelReports" */'./views/panel/Reports'),
      meta: {
        auth: true
      }
    },
    {
      path: '/panel/dataset',
      name: 'panelDataset',
      component: () => import(/* webpackChunkName: "panelDatasetViewer" */'./views/panel/DatasetViewer'),
      meta: {
        auth: true
      }
    },
    {
      path: '/panel/carParks',
      name: 'carParks',
      component: () => import(/* webpackChunkName: "panelDatasetViewer" */'./views/panel/CarParkPermissions'),
      meta: {
        auth: true
      }
    },
    // {
    //   path: '/panel/map/manager',
    //   name: 'panelMapManager',
    //   component: () => import(/* webpackChunkName: "panelMapManager" */'./views/panel/ManagerMap')
    // },
    {
      path: '*',
      component: () => import(/* webpackChunkName: "home" */'./views/Home'), // or maybe pretty 404 page?
      meta: {
        background: true
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.auth) && !process.env.VUE_APP_NO_AUTH) {
    if (store.state[AUTH_MODULE].auth) {
      next()
      return
    }

    if (!process.env.VUE_APP_HIDDEN_MODE) {
      next({ name: 'home', params: { type: 'home', authError: true } })
    }
  } else {
    next()
  }
})

export default router
